import React, { useEffect, useState } from 'react';
import { getEcho } from '../echo';
import api from '../api';

const BroadcastTest = () => {
    const [status, setStatus] = useState('Initializing...');
    const [messages, setMessages] = useState([]);
    const [channelStatus, setChannelStatus] = useState({});

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user) {
            setStatus('No user found. Please login first.');
            return;
        }

        const echo = getEcho();

        if (!echo) {
            setStatus('❌ Echo not initialized. Please login first.');
            addMessage('Echo instance is null - authentication token not found');
            return;
        }

        // Test Pusher connection
        echo.connector.pusher.connection.bind('connected', () => {
            setStatus('✅ Connected to Pusher');
            addMessage('Connected to Pusher successfully');
        });

        echo.connector.pusher.connection.bind('error', (err) => {
            setStatus('❌ Connection error');
            addMessage(`Connection error: ${JSON.stringify(err)}`);
        });

        // Try to subscribe to user's private channel
        const channelName = `App.Models.User.${user.id}`;
        addMessage(`Attempting to subscribe to: ${channelName}`);

        const channel = echo.private(channelName);

        channel.subscribed(() => {
            addMessage(`✅ Successfully subscribed to ${channelName}`);
            setChannelStatus(prev => ({ ...prev, [channelName]: 'subscribed' }));
        });

        channel.error((error) => {
            addMessage(`❌ Subscription error: ${JSON.stringify(error)}`);
            setChannelStatus(prev => ({ ...prev, [channelName]: 'error' }));
        });

        // Listen for test notifications
        channel.notification((notification) => {
            addMessage(`📬 Notification received: ${JSON.stringify(notification)}`);
        });

        return () => {
            if (echo) {
                echo.leave(channelName);
            }
        };
    }, []);

    const addMessage = (msg) => {
        setMessages(prev => [...prev, { time: new Date().toLocaleTimeString(), msg }]);
    };

    const sendTestNotification = async () => {
        try {
            addMessage('Sending test broadcast...');
            const response = await api.post('/test-broadcast');
            addMessage(`Test broadcast sent: ${JSON.stringify(response)}`);
        } catch (error) {
            addMessage(`Error sending test: ${error.message}`);
        }
    };

    return (
        <div style={{ padding: '20px', fontFamily: 'monospace', backgroundColor: '#1e1e1e', color: '#fff', minHeight: '100vh' }}>
            <h2>Laravel Echo Broadcasting Test</h2>
            <div style={{ marginBottom: '20px' }}>
                <strong>Status:</strong> {status}
            </div>

            <div style={{ marginBottom: '20px' }}>
                <strong>Channel Subscriptions:</strong>
                <ul>
                    {Object.entries(channelStatus).map(([channel, status]) => (
                        <li key={channel}>
                            {channel}: <span style={{ color: status === 'subscribed' ? '#4ade80' : '#ef4444' }}>{status}</span>
                        </li>
                    ))}
                </ul>
            </div>

            <button
                onClick={sendTestNotification}
                style={{
                    padding: '10px 20px',
                    backgroundColor: '#3b82f6',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    marginBottom: '20px'
                }}
            >
                Send Test Broadcast
            </button>

            <div style={{ backgroundColor: '#2d2d2d', padding: '15px', borderRadius: '5px', maxHeight: '400px', overflowY: 'auto' }}>
                <h3>Debug Log:</h3>
                {messages.map((m, i) => (
                    <div className="ui-font-12" key={i} style={{ marginBottom: '5px' }}>
                        <span style={{ color: '#888' }}>[{m.time}]</span> {m.msg}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BroadcastTest;
